<template>
    <NuxtLink class="product-card" :to="localePath(`${base}${product.id}`)">
        <div class="img-wrapper">

            <img :src="product.image" alt="">
        </div>
        <p>{{ product.title[locale] }}</p>
    </NuxtLink>
</template>

<script setup>
const { locale } = useI18n()
defineProps(['product', 'base'])
const localePath = useLocalePath()
</script>